import { loadCSS } from '../../utils';
let view = null;

export default {
	namespace: 'single-project',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPDATA.themeUrl + '/dist/css/t-single-project.css');

		const { default: SingleProject } = await import(
			/* webpackChunkName: "single-project" */ '../../templates/SingleProject'
		);
		view = new SingleProject(next.container);
		await view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
